const servicesSwiper = new Swiper('.insights-slider', {
    // Optional parameters
    loop: false,
    slidesPerView: 'auto',
    //slidesPerViewAutoSlideSize: 500,
    spaceBetween: 40,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    speed: 800,
    navigation: {
        nextEl: '.related-insights .swiper-controls .next',
        prevEl: '.related-insights .swiper-controls .prev',
    },
});